module.exports = __webpack_public_path__ + "media/flags/be-584d2a3f.svg";